import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const Shield14 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={14}
    contrast={contrast}
    className={className}
  >
    <path
      d='M5.99993 9.06072L10.0303 5.03039L8.9696 3.96973L5.99993 6.9394L5.03026 5.96973L3.9696 7.03039L5.99993 9.06072Z'
      fill='currentColor'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M7.24515 0.284162C7.08332 0.251796 6.91668 0.251796 6.75485 0.284162L2.25486 1.18416C1.67058 1.30102 1.25 1.81404 1.25 2.40989V9.71689C1.25 10.156 1.48037 10.5629 1.85688 10.7888L6.35688 13.4888C6.75273 13.7263 7.24727 13.7263 7.64312 13.4888L12.1431 10.7888C12.5196 10.5629 12.75 10.156 12.75 9.71689V2.40989C12.75 1.81404 12.3294 1.30102 11.7451 1.18416L7.24515 0.284162ZM2.75 2.61484L7 1.76484L11.25 2.61484V9.57534L7 12.1253L2.75 9.57534V2.61484Z'
      fill='currentColor'
    />
  </Svg>
);

Shield14.displayName = 'Shield14';
export default Shield14;
